import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {ItemAnimationObject} from '@PosterWhiteboard/animation/animation.class';

export function useGetKeyFromItemIntroAnimation<T extends keyof ItemAnimationObject>(key: T): ItemAnimationObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'introAnimation' in item && item.introAnimation[key] !== undefined) {
      return item.introAnimation[key];
    }

    return undefined;
  });
}
